import styled from 'styled-components';

export const Container = styled.div`
    background-color: white;
    width: 25vw;
    height: 100%;
    > .ant-list {
        height: 100%;

    }
}
`;

export const Header = styled.div`
    height: 35px;
    > button {
        float: right;
        margin-left: 10px;
    }
}
`;
